import React, { useState } from "react";
import { CustomerFeedbackDetailsTableProps } from "./types";
import { Rating } from "@material-ui/lab";
import StatTable from "../../components/StatTable";
import {
  Dialog,
  DialogContent,
  IconButton,
  useMediaQuery
} from "@material-ui/core";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import CloseIcon from "@material-ui/icons/Close";
import { UserOverview } from "../../../users/UserOverview";
import useStyles from "./styles";
import { useTheme } from "@material-ui/core/styles";

const CustomerFeedbackDetailsTable = ({
  feedbacks
}: CustomerFeedbackDetailsTableProps) => {
  const classes = useStyles();
  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.down("xs"));

  const [userId, setUserId] = useState("");

  return (
    <>
      <StatTable
        exportName={"Customer feedback comments"}
        columns={[
          {
            title: "Created",
            field: "created",
            cellStyle: { padding: "8px", width: "10%" }
          },
          {
            title: "Stars",
            field: "stars",
            cellStyle: { padding: "8px" },
            render: (rowData: any) => (
              <Rating
                name="average"
                defaultValue={rowData.stars === 0 ? 1 : rowData.stars}
                readOnly
                precision={0.25}
                size={"small"}
                aria-label={"rating"}
              />
            )
          },
          {
            title: "Comment",
            field: "comment",
            cellStyle: { padding: "8px", width: "70%" }
          }
        ]}
        data={feedbacks.sort((a: any, b: any) =>
          a.created < b.created ? 1 : -1
        )}
        actions={[
          {
            icon: "account_circle",
            iconProps: { style: { color: "#1f8434" } },
            tooltip: "Go to User",
            onClick: (event: any, rowData: any) => setUserId(rowData.userId)
          }
        ]}
        pageSize={5}
        pageSizeOptions={[5, 10, 20]}
        dense
        isLoading={false}
      />

      <Dialog
        onClose={() => setUserId("")}
        open={userId !== ""}
        fullWidth={true}
        fullScreen={mobile}
        maxWidth={"xl"}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <MuiDialogTitle style={{ height: 50 }} disableTypography>
          <IconButton
            aria-label="close"
            className={classes.closeButton}
            onClick={() => setUserId("")}
          >
            <CloseIcon />
          </IconButton>
        </MuiDialogTitle>
        <DialogContent style={mobile ? { padding: 0 } : {}}>
          <UserOverview inputUserId={userId} />
        </DialogContent>
      </Dialog>
    </>
  );
};
export default CustomerFeedbackDetailsTable;
